import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'

export const NEXUS_DEMO_DONE_VERIFY_AI_LOG_STEPS = [
  {
    durationMs: 3200,
    actionName: 'Verified DNS propagation',
    arguments: { toolName: 'dig', args: { domain: 'app.nexusb2b.com' } },
    result: { nameservers: 'ns-cloud-a1.googledomains.com' },
    status: 'ok',
    stepNarration: 'Nameservers are pointing to Google Cloud as expected.',
  },
  {
    durationMs: 8400,
    actionName: 'Wrote file',
    arguments: {
      op: 'write',
      path: '/reports/nexus-journey-summary.md',
      content: '# NexusB2B Journey Summary\n...',
    },
    result: { ok: true },
    status: 'ok',
    stepNarration: 'Compiling the structured journey summary tables for your review.',
  },
]

/** @param {{ streaming?: boolean }} [opts] */

export function nexusDoneVerifyLogBlock(opts = {}) {
  const streaming = opts.streaming ?? false
  return {
    type: 'aiResponseLog',
    status: 'ok',
    showLogStatus: false,
    ...(streaming
      ? { stepTemplates: NEXUS_DEMO_DONE_VERIFY_AI_LOG_STEPS }
      : { steps: buildWorkflowTimeline(NEXUS_DEMO_DONE_VERIFY_AI_LOG_STEPS) }),
  }
}

/**
 * @param {{ streaming?: boolean }} [opts]
 * @returns {object[]}
 */
